import React from "react";
import { createRoot } from "react-dom/client";
import CarbonProvider from "carbon-react/esm/components/carbon-provider";
import TokensWrapper from "carbon-react/esm/components/tokens-wrapper";
import GlobalStyle from "carbon-react/esm/style/global-style";
import sageTheme from "carbon-react/esm/style/themes/sage";
import "carbon-react/lib/style/fonts.css";

import { App } from "./App";
import { EmbeddedSessionProvider } from "./auth/EmbeddedSessionProvider";
import "./styles/application.css";

const container = document.getElementById("app");

if (!container) {
  throw new Error("Loan Management application container was not found.");
}

createRoot(container).render(
  <React.StrictMode>
    <TokensWrapper>
      <CarbonProvider theme={sageTheme} validationRedesignOptIn>
        <GlobalStyle />
        <EmbeddedSessionProvider>
          <App />
        </EmbeddedSessionProvider>
      </CarbonProvider>
    </TokensWrapper>
  </React.StrictMode>,
);
